import React from "react";
import { PifApprovalStep } from "../../pages/supervision/PostInterviewForm/types";

interface PostIFApprovalDotsProps {
  steps: PifApprovalStep[];
}

const PostIFApprovalDots: React.FC<PostIFApprovalDotsProps> = ({ steps }) => {
  // Bug 84702: states only - no returned or declined reason. The reason is free text, often long,
  // and the detail dialog and Signature History already show it (agreed with the reporter).
  const summary = steps.map((step) => `${step.label}: ${step.detail}`).join(", ");

  return (
    <span className="postif-dots" title={summary} aria-label={summary} data-testid="postif-pipeline">
      {steps.map((step) => (
        <span
          key={step.label}
          className={`postif-dots__dot postif-dots__dot--${step.state}`}
          data-testid={`postif-pipeline-${step.state}`}
        />
      ))}
    </span>
  );
};

export default PostIFApprovalDots;
